import useAlias from '@alias';
import { TextField } from '@mui/material';
import { AddUserFormValues } from '@src/hooks/api/mutations/useUserCreate';
import { useFormContext } from 'react-hook-form';

function UsernameField() {
  const alias = useAlias();
  const {
    register,
    formState: { errors },
  } = useFormContext<AddUserFormValues>();

  return (
    <TextField
      fullWidth
      label={alias('Username')}
      {...register('username')}
      error={!!errors.username}
      helperText={errors.username?.message}
      size='small'
    />
  );
}

export default UsernameField;
